import React, { Children } from "react"
import styles from "./form.module.css"
const Form = ({
  onSubmit = () => {},
  children,
  is_admin = false,
  className = "",
  style = {},
}) => {
  return (
    <form
      onSubmit={onSubmit}
      className={`${styles.form} ${className} ${
        is_admin ? styles.admin : styles.non_admin
      }`}
      style={style}
    >
      {children}
    </form>
  )
}

export default Form
